export const chartColors = [
  "#a0d010",
  "#c0c0c0",
  "#a00000",
]
